<template>
  <div class="diagnosis-editor">
    <DiagnosisChooser @select="addDiagnosis" v-if="editable" />
    <DiagnosisList
      :diagnoses="localDiagnoses"
      :editable="editable"
      @change="emit('update:modelValue', localDiagnoses)"
    />
  </div>
</template>

<script setup lang="ts">
import type Diagnosis from "../../types/Diagnosis";
import { ref } from "vue";
import DiagnosisChooser from "./DiagnosisChooser.vue";
import DiagnosisList from "./DiagnosisList.vue";

const props = withDefaults(
  defineProps<{ modelValue: Diagnosis[]; editable?: boolean }>(),
  { editable: false }
);

const emit = defineEmits(["update:modelValue"]);

const localDiagnoses = ref<Diagnosis[]>(props.modelValue);

function addDiagnosis(diagnosis: Diagnosis) {
  localDiagnoses.value.push(diagnosis);
  emit("update:modelValue", localDiagnoses.value);
}
</script>
